export default __webpack_public_path__ + "static/media/bg7.1a554fc8.png";